// extracted by mini-css-extract-plugin
export default {"module":"quizControl_module__JgIHB","prev":"quizControl_prev__E00x8","next":"quizControl_next__0mzBR","confirm":"quizControl_confirm__MW7TX"};